import ErrorBoundary from "./ErrorBoundary";
import { BasePageProps } from "../types/components";

function ResourcesPage({ userMode, userAge }: BasePageProps) {
  return (
    <ErrorBoundary>
      <div>
        <h1>Resources Page</h1>
        <p>Here are some resources to help you understand your feelings.</p>
        {userMode && (
          <div>
            <p>Mode: {userMode}</p>
            {userAge && <p>Age: {userAge}</p>}
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
}

export default ResourcesPage;
